<template>
  <div class="container-home op-3 b-fff">
    <img src="~/assets/img/home.png" alt="" />

    <div class="card-inline">
      <p class="welcome">
        {{
          `欢迎使用南京${
            env !== 'production' ? '云次方' : 'CUPSHE'
          }统一门户系统`
        }}！
      </p>
      <a-card hoverable class="more-system">
        <div class="f1 df aic">
          <a href="/systemList" class="f1 tal">查看更多系统</a>
          <a href="/systemList"><ArrowRightOutlined key="arrowRight"/></a>
        </div>
      </a-card>
    </div>
  </div>
  <!-- <p
    style="color:red;text-align:center ;margin-top: 30%;font-size:30px;
  line-height:40px;"
  >
    今天下午4:00-4:30，系统进行全面升级，请在4点之前保存信息，<br />并在此期间，勿操作系统，感谢对产研的理解和支持！
  </p> -->
</template>
<script>
import { ArrowRightOutlined } from '@ant-design/icons-vue'
export default {
  components: {
    // EllipsisOutlined,
    ArrowRightOutlined
  },
  setup() {
    const more = () => {
      location.href = '/menus'
    }
    return {
      env: process.env.VUE_APP_ENV,
      more
    }
  }
}
</script>
<style lang="scss" scoped>
.container-home {
  text-align: center;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  font-size: 30px;
  color: #a7a7a7;

  flex-direction: column;
  position: relative;

  img {
    width: 708px;
    height: 360px;
    /* opacity: 0.3; */
  }
  .welcome {
    text-shadow: rgb(209, 206, 206) 10px 10px 7px;
    /* margin-top: 50px; */
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 40px;
    /* opacity: 0.3; */
  }
}
.card-inline {
  margin-top: 50px;
  position: relative;
  width: 100%;
  text-align: center;
  /* position: absolute;
  top: 0;
  left: 0;
  right: 0; */
  display: flex;
  justify-content: center;
}
.portal-ant-card {
  margin-right: 16px;
  border-radius: 4px;
  position: absolute;
  right: 0;
  top: -50%;
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15) \9;
}
.f1 {
  flex: 1;
}
</style>
<style lang="scss">
.portal-ant-card-actions {
  padding: 0 16px;
  display: flex;
  li {
    width: unset !important;
    &:not(:last-child) {
      border-right: none;
      flex: 1;
    }
  }
}

.more-system {
  position: absolute;
  right: 0;
  top: -16px;
  width: 300px;
}
</style>
